import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { cityFromZip, rateForCity } from '../../lib/tax';

// Street, ZIP and city for the service location. ZIP auto-picks the city (and tax rate).
export const AddressFields = ({ form, set, errors, taxData }) => {
  const onZip = (zip) => {
    const clean = zip.replace(/\D/g, '').slice(0, 5);
    set('service_zip', clean);
    const city = cityFromZip(clean, taxData);
    if (city) set('service_city', city);
  };
  const rate = rateForCity(form.service_city, taxData);

  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="service_address" className="text-neutral-700">Service Address *</Label>
        <Input
          id="service_address"
          value={form.service_address}
          onChange={(e) => set('service_address', e.target.value)}
          placeholder="Street address where we'll detail your vehicle"
          autoComplete="street-address"
          className="bg-white border-neutral-300 text-neutral-900 mt-1 h-12 sm:h-10 text-base"
          data-testid="input-service-address"
        />
        {errors.service_address && <p className="text-red-600 text-xs mt-1">{errors.service_address}</p>}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div>
          <Label htmlFor="service_zip" className="text-neutral-700">ZIP *</Label>
          <Input
            id="service_zip"
            inputMode="numeric"
            value={form.service_zip}
            onChange={(e) => onZip(e.target.value)}
            placeholder="87031"
            autoComplete="postal-code"
            className="bg-white border-neutral-300 text-neutral-900 mt-1 h-12 sm:h-10 text-base"
            data-testid="input-service-zip"
          />
          {errors.service_zip && <p className="text-red-600 text-xs mt-1">{errors.service_zip}</p>}
        </div>
        <div className="sm:col-span-2">
          <Label htmlFor="service_city" className="text-neutral-700">City *</Label>
          <select
            id="service_city"
            value={form.service_city}
            onChange={(e) => set('service_city', e.target.value)}
            className="mt-1 w-full h-12 sm:h-10 px-3 text-base bg-white border border-neutral-300 rounded-md text-neutral-900 focus:outline-none focus:border-red-500"
            data-testid="select-service-city"
          >
            <option value="">Select your city…</option>
            {taxData?.rates.map((r) => (
              <option key={r.city} value={r.city}>{r.city}</option>
            ))}
          </select>
          {errors.service_city && <p className="text-red-600 text-xs mt-1">{errors.service_city}</p>}
        </div>
      </div>
      {rate && (
        <p className="text-xs text-neutral-500" data-testid="tax-rate-note">
          Local tax for {rate.city}: <span className="font-semibold text-neutral-800">{rate.rate_percent}%</span>
        </p>
      )}
    </div>
  );
};
